// ─── 👥 Gli amici nel bot, nella scheda del socio (27/10/2026) ────────────────
//
// Mockup «Amici nel gestionale», 3A: i suoi amici, chi ha lui fra gli amici e i suoi gruppi, solo da leggere. Si
// cambiano solo dal bot, dal socio. Il riquadro c'è solo se c'è qualcosa da mostrare.

import { useQuery } from '@tanstack/react-query';
import type { AmiciNellaScheda } from '@pmo/shared';
import { chiama } from '../../lib/api.js';
import { Guasto } from '../../components/pezzi.js';

export function AmiciDelSocio({ id }: { id: string }): React.JSX.Element | null {
  const a = useQuery({
    queryKey: ['amici-socio', id],
    queryFn: () => chiama<AmiciNellaScheda>('GET', `/members/${id}/friends`),
  });
  if (a.error) return <Guasto errore={a.error} />;
  if (!a.data) return null;
  const x = a.data;
  if (x.friends.length === 0 && x.friendOf.length === 0 && x.groups.length === 0) return null;
  const nomi = (l: { name: string }[]) => l.map((p) => p.name).join(', ');

  return (
    <section className="riquadro">
      <h3>👥 Amici nel bot</h3>
      {x.friends.length > 0 && (
        <p className="piccolo">
          Suoi amici ({x.friends.length}): <strong>{nomi(x.friends)}</strong>
        </p>
      )}
      {x.friendOf.length > 0 && (
        <p className="piccolo">
          Lo hanno fra gli amici ({x.friendOf.length}): <strong>{nomi(x.friendOf)}</strong>
        </p>
      )}
      {x.groups.map((g) => (
        <p className="piccolo" key={g.id}>
          Gruppo «{g.title}» ({g.members.length}): {g.members.join(', ')}
        </p>
      ))}
      <p className="tenue piccolo">Si cambiano solo dal bot, dal socio.</p>
    </section>
  );
}
